import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Configuration } from '../../app.constants';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class DesignService {
  private _designUrl = this._configuration.apiUrl + "/v2/design";

  constructor(private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }

  addDesign(design: { name: string, collection_id: number }): any {
    throw new Error("Method not implemented.");
  }

  removeDesign(design_id: string): any {
    throw new Error("Method not implemented.");
  }

  getDesigns(): any {
    let h = this._authService.getHeaders();
    let s = new URLSearchParams();

    return this._http.get(this._designUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['designs'] == null || !Array.isArray(body['designs']))
          return [];
        return body['designs'];
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/services/design.service.ts